import {PolymerElement, html} from '@polymer/polymer';
import '@polymer/polymer/lib/elements/dom-repeat.js';
import {ScopeBinding} from '../behaviors/keli-binding-behavior.js';

class KeliGroup extends ScopeBinding(PolymerElement) {
  static get template() {
    return html`
<style>
:host {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  text-align: var(--keli-group-align, left);
}
</style>

<slot></slot>`;
  }

  static get is() {
    return 'keli-group';
  }

  static get properties() {
    return {
      align: {type: String, scopevar: true, observer: 'alignChanged'},
      isBlockPanelElement: {type: Boolean, value: true},
      isRegionElement: {type: Boolean, value: true},
      keliControlTypes: {type: Array, value: ['layout-group']}
    }
  }

  alignChanged(newValue) {
    this.updateStyles({'--keli-group-align': newValue || ''});
  }
}

customElements.define(KeliGroup.is, KeliGroup);
export {KeliGroup};
